import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import * as ticketingStates from 'store/updateTicketing';
import { getCopy } from 'utils/copy';
import { Link } from 'components/core/link/link';
import s from 'components/shared/theaters/ticketing/ticketError/ticketError.sss';


export default class TicketError extends Component {

	reopenTicketing = () => {
		Store.emit(actions.REOPEN_TICKETING);
	}

	render(props) {
		const {
			ticketing // Object - the ticketing state
		} = props;

		const {
			message, // Error message: can be a localised message, a plain message or the default message.
			fallbackUrl
		} = ticketing;

		let messageToShow = '';

		if (typeof message === 'string') {
			if (message.charAt(0) === '$') {
				messageToShow = getCopy(message);
			} else {
				messageToShow = message;
			}
		}

		if (!messageToShow || messageToShow === '') {
			messageToShow = getCopy('UNKNOW_ERROR');
		}

		// Button text: if the step before the error occurred was before seating, show the
		// 'book tickets again' text, otherwise show 'grab seats again'
		let btnText = '';

		const prevState = ticketing.prevState;
		const ticketingOrder = ticketingStates.ticketingOrder;

		const seatStepIndex = ticketingOrder.indexOf(ticketingStates.SELECT_SEATS);
		const prevStepIndex = ticketingOrder.indexOf(prevState);

		if (prevStepIndex >= seatStepIndex && ticketing.seatingSupported) {
			btnText = getCopy('GRAB_SEATS_AGAIN');
		} else {
			btnText = getCopy('BOOK_TICKETS_AGAIN');
		}

		return (
			<div class={s.container}>
				<h2 class={s.message}>{messageToShow}</h2>
				<button class={s.btn} onClick={this.reopenTicketing}>{btnText}</button>
				{fallbackUrl && (
					<Link target="_blank" href={fallbackUrl} class={s.btn} renderCustomChild>{getCopy('GO_TO_THEATER_WEBSITE')}</Link>
				)}
			</div>
		);
	}

}
